import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterHelperDialog',
  emits: ['close'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mb-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "text-subtitle-1 d-flex align-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: "mdi-information-outline",
            start: "",
            size: "small"
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" Filter-Syntax ")),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            variant: "text",
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        _: 1,
        __: [1]
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_text, { class: "text-body-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "mb-2" }, [
                    _createElementVNode("strong", null, "Vergleiche:")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, ">100"),
                    _createTextVNode(" - Größer als 100 ")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, ">=100"),
                    _createTextVNode(" - Größer oder gleich 100 ")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, "<100"),
                    _createTextVNode(" - Kleiner als 100 ")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, "<=100"),
                    _createTextVNode(" - Kleiner oder gleich 100 ")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, "10..50"),
                    _createTextVNode(" - Zwischen 10 und 50 ")
                  ], -1)
                ])),
                _: 1,
                __: [2]
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("div", { class: "mb-2" }, [
                    _createElementVNode("strong", null, "Text-Filter:")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, "motor"),
                    _createTextVNode(" - Enthält \"motor\" ")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, "*motor*"),
                    _createTextVNode(" - Enthält \"motor\" (explizit) ")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, "motor*"),
                    _createTextVNode(" - Beginnt mit \"motor\" ")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, "*350"),
                    _createTextVNode(" - Endet mit \"350\" ")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, "!=BEEND"),
                    _createTextVNode(" - Nicht \"BEEND\" ")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, "TDE,TDM"),
                    _createTextVNode(" - Ist \"TDE\" oder \"TDM\" ")
                  ], -1),
                  _createElementVNode("div", { class: "filter-example" }, [
                    _createElementVNode("code", null, "!TDE,TDM,PROD"),
                    _createTextVNode(" - Ist Alles außer \"TDE\", \"TDM\" und \"PROD\" ")
                  ], -1)
                ])),
                _: 1,
                __: [3]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})